// vue components
import TravelListItem from './vue/components/_travel-list-item.vue';
import FilterCriteriaDate from './vue/components/_filter-criteria-date.vue';
import FilterCriteriaList from './vue/components/_filter-criteria-list.vue';
import FilterCriteriaText from './vue/components/_filter-criteria-text.vue';
import FilterCriteriaNumber from './vue/components/_filter-criteria-number.vue';
import FilterCriteriaCheckbox from './vue/components/_filter-criteria-checkbox.vue';
import FilterCriteriaListRange from './vue/components/_filter-criteria-list-range.vue';
import FilterCriteriaRadio from './vue/components/_filter-criteria-radio.vue';
import FilterCriteriaWeeks from './vue/components/_filter-criteria-weeks.vue';
import TravelTileItem from './vue/components/_travel-tile-item.vue';

Vue.component('filter-criteria-date', FilterCriteriaDate);
Vue.component('filter-criteria-list', FilterCriteriaList);
Vue.component('filter-criteria-text', FilterCriteriaText);
Vue.component('filter-criteria-number', FilterCriteriaNumber);
Vue.component('filter-criteria-checkbox', FilterCriteriaCheckbox);
Vue.component('filter-criteria-list-range', FilterCriteriaListRange);
Vue.component('filter-criteria-radio', FilterCriteriaRadio);
Vue.component('filter-criteria-weeks', FilterCriteriaWeeks);
Vue.component('travel-list-item', TravelListItem);
Vue.component('travel-tile-item', TravelTileItem);